import { Directive } from '@angular/core';
import { NgForm, ControlContainer } from '@angular/forms';

// this directive provides a workaround for nested, template driven forms
// https://stackoverflow.com/a/45307924/4746171

@Directive({
	selector: '[provide-parent-form]',
	providers: [
		{
			provide: ControlContainer,
			useFactory(form: NgForm) {
				return form;
			},
			deps: [NgForm]
		}
	]
})

export class ProvideParentFormDirective {

}
